var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tagType,{tag:"component",staticClass:"EPiLink",class:_vm.className,attrs:{"to":_vm.url,"href":_vm.url,"target":_vm.target,"title":_vm.title,"aria-label":_vm.ariaLabel}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }